// extracted by mini-css-extract-plugin
export var option = "_50-1";
export var optionActive = "_50-2";
export var pill = "_50-0";